<template>
  <aha-antd-button
    v-aha-emit-action
    name="presentation-table-present"
    class="present-button"
    :submitting="isCheckingPerm"
    is-loading-inline
    size="sm"
    @click="handlePresentNowButtonClick"
  >
    <span>Present</span>
  </aha-antd-button>
</template>

<script>
import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import constants from '@/constant'
import msTeamsUtils from '@/utils/ms-teams'
import util from '@/util'
import PresentationApi from '@/api/presentation'
import PresentationMixpanelTracker from '@/utils/mixpanel/presentation.mixpanel-tracker'

export default {
  props: {
    presentation: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isCheckingPerm: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    async handlePresentNowButtonClick() {
      this.isCheckingPerm = true

      if (this.$store.state.isMSTeamsApp) {
        await msTeamsUtils.setPresentContext(this.$store.state.presentation)
        return
      }

      // const hasPerm = await this.$func.isCurrentEditorRealtime(this.presentation, this)
      // if (!hasPerm) return

      await this.takeover()
      this.trackStartPresenting()
      this.isCheckingPerm = false
      this.$router.push({
        name: 'PresentationDetail',
        params: {
          id: this.presentation.id,
        },
        query: {
          presenting: true,
        },
      })
    },
    trackStartPresenting() {
      const presentationTracker = new PresentationMixpanelTracker(this.presentation, this.$route.name, this.currentUser)
      presentationTracker.trackStartPresenting('Presentation List > Present Button', this.presentation.id, true) // needMixpanelRegister = true
    },
    async takeover() {
      try {
        await PresentationApi.takeOver(this.presentation.id)
        util.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Succeeded')
      } catch (e) {
        Sentry.captureException(e)
        util.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Failed')
      }
    },
  },
}
</script>
